import { render, staticRenderFns } from "./CreateEditReport.vue?vue&type=template&id=56dd55b3"
import script from "./CreateEditReport.vue?vue&type=script&lang=js"
export * from "./CreateEditReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports